<template>
  <b-image v-bind="$attrs" :src="src" :alt="alt"> </b-image>
</template>

<script>
export default {
  name: "BaseBuefyImage",
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    }
  }
};
</script>
